module.exports = __webpack_public_path__ + "static/img/1_0030.e5aa5f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0030.jpg
// module id = Bu0J
// module chunks = 0